/**
 * Default theme — the original Optinégo look.
 *
 * Every other theme inherits from this one (see `../index.js`), so a custom
 * theme only needs to declare the keys it overrides.
 */
export default {
  id: 'optinego',
  // Name shown in the theme picker (Settings).
  label: 'Optinégo',

  /** Branding text. */
  brand: {
    appName: 'Optinégo',
    // Short form used in sentences ("<assistantName> réfléchit…").
    assistantName: 'OptiNégo',
    // Login screen product name ("Accédez à votre espace …").
    loginName: 'OPTI NÉGO',
    company: 'StarkIA Technologies',
    tagline: "L'IA qui optimise vos devis matériaux.",
    loginBullets: [
      'Choix de produits optimisés',
      'Intégration ERP & catalogues fournisseurs',
      'Gains de temps pour les commerciaux',
    ],
    // Footer line of exported PDFs.
    pdfFooter: 'Document généré par Optinego',
  },

  /** Image URLs (served from /public or absolute). */
  assets: {
    logo: '/logo.png',
    favicon: '/favicon.ico',
    aiAvatar: '/assets/ai-avatar.png',
  },

  /** Vuetify palettes + extra tokens exposed as CSS variables (--app-*). */
  colors: {
    light: {
      primary: '#f7841d',
      secondary: '#021e44',
      // Call-to-action colour (send button, active item); defaults to primary.
      cta: '#f7841d',
    },
    dark: {
      primary: '#f7841d',
      secondary: '#6dbdff',
      cta: '#f7841d',
    },
    // Non-Vuetify tokens, per mode. Exposed as --app-<kebab-name>.
    tokens: {
      light: {
        loginInfoBg: '#F6F6F6',
        assistantBubbleBg: '#F3F6FB',
        assistantBubbleText: '#111111',
        thinkingDot: '#1976D2',
        accountIcon: '#f7841d',
      },
      // Same values as light: the original UI never varied these in dark mode.
      dark: {
        loginInfoBg: '#F6F6F6',
        assistantBubbleBg: '#F3F6FB',
        assistantBubbleText: '#111111',
        thinkingDot: '#1976D2',
        accountIcon: '#f7841d',
      },
    },
  },

  fonts: {
    family: "'Roboto', sans-serif",
    mono: 'monospace',
    // Optional stylesheet URL injected at startup (e.g. Google Fonts).
    stylesheet: 'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900',
  },

  layout: {
    sidebarWidth: 300,
    // 'left' | 'right'
    sidebarPosition: 'left',
    // Vuetify colour of the selected conversation/project row in the sidebar.
    activeItemColor: 'secondary',
    sidebarLogoHeight: 48,
    loginLogoHeight: 72,
    // Render the login form pane with the dark Vuetify theme (use with a dark `loginFormBg`).
    loginFormDark: false,
    // Colour the whole right-hand content pane (header, chat, footer) with the
    // `contentBg`/`contentText` tokens and render it with Vuetify's dark theme.
    contentDark: false,
    // 'split' (info panel + form) | 'centered' (logo + form only)
    loginLayout: 'split',
    showFooter: true,
    // Corner radius (px) of cards/buttons/bubbles' default rounding.
    borderRadius: 4,
  },
}
